export default "__VITE_ASSET__DinjovuN__"